import { render, staticRenderFns } from "./SimpleCheckbox.vue?vue&type=template&id=a370c946&scoped=true&"
import script from "./SimpleCheckbox.vue?vue&type=script&lang=js&"
export * from "./SimpleCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCheckbox.vue?vue&type=style&index=0&id=a370c946&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a370c946",
  null
  
)

export default component.exports